import { useQuery } from '@tanstack/react-query';
import { ApiService } from '../../services/apiService';
import { Show } from '../../types/Show';
import { cachingStrategyService, DataType } from '../../services/cachingStrategyService';

export const LIVE_SHOW_QUERY_KEY = ['liveShow'] as const;

export const useLiveShowQuery = () => {
  // Get optimized caching strategy for live data
  const cacheStrategy = cachingStrategyService.getStrategy(DataType.LIVE_DATA);
  
  return useQuery({
    queryKey: LIVE_SHOW_QUERY_KEY,
    queryFn: async (): Promise<Show | null> => {
      const response = await ApiService.getLiveShow();
      if (!response.success) {
        throw new Error(response.error || 'Failed to fetch live show');
      }
      return response.data;
    },
    // Apply centralized caching strategy for live data
    staleTime: cacheStrategy.staleTime,
    gcTime: cacheStrategy.gcTime,
    refetchInterval: cacheStrategy.refetchInterval,
    refetchIntervalInBackground: cacheStrategy.refetchIntervalInBackground,
    refetchOnWindowFocus: cacheStrategy.refetchOnWindowFocus,
    refetchOnReconnect: cacheStrategy.refetchOnReconnect,
    retry: cacheStrategy.retry,
    retryDelay: cacheStrategy.retryDelay,
  });
};
